import { fetchSC } from "src/utils/fetch-sc";

type ValidateEmailQueryResponse = {
  validateEmail: boolean;
};

type ValidateEmailResponse = {
  isValid: boolean;
};

const VALIDATE_EMAIL_QUERY = `query validateEmail($email: String!) {
        validateEmail(email: $email)
      }`;

async function validateEmail(email: string): Promise<ValidateEmailResponse> {
  const { data } = await fetchSC<ValidateEmailQueryResponse>({
    query: VALIDATE_EMAIL_QUERY,
    variables: { email },
  });

  return { isValid: data.validateEmail || false };
}

export { validateEmail };
